import { render } from "./promotions-section.vue?vue&type=template&id=dcb3bf52&scoped=true"
import script from "./promotions-section.vue?vue&type=script&lang=js"
export * from "./promotions-section.vue?vue&type=script&lang=js"

import "./promotions-section.vue?vue&type=style&index=0&id=dcb3bf52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb3bf52"]])

export default __exports__